export default __webpack_public_path__ + "static/images/banner.3eab6a5f.png";